import { createFileRoute } from '@tanstack/react-router'
import { PersonalNotePageLayout } from '../components/PersonalNotePageLayout'
import { usePersonalNoteForDate } from '../hooks/usePersonalNoteForDate'
import { formatDailyNoteTitle, isToday } from '../utils/noteDateUtils'
import { useLocale } from '@/lib/i18n/LocaleProvider'
import { useTimezone } from '@/store/UserPreferencesStore'

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/notes/daily/$noteDate',
)({
  component: DailyNotePage,
})

function DailyNotePage() {
  const { locale } = useLocale()
  const timezone = useTimezone()
  const { noteDate } = Route.useParams()
  const noteState = usePersonalNoteForDate('daily', noteDate)

  return (
    <PersonalNotePageLayout
      noteType="daily"
      noteDate={noteDate}
      title={formatDailyNoteTitle(noteDate, locale)}
      isCurrentPeriod={isToday(noteDate, timezone)}
      currentPeriodLabelKey="today"
      listTitleKey="dailyNotes"
      noteState={noteState}
    />
  )
}
